import axios from "axios"
import { Service } from "@front-apps/core/services/Service"
import StoreService from "@front-apps/core/services/store"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL

class LinkAPI {
    public static async createShortLink(
        params: any,
        groupId: string,
        pdv: any
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const token = await StoreService.getInstance().persistant.get("token")
        const authLink = process.env.REACT_APP_CUSTOMER_AUTH_LINK
        let linkQuery = ""
        if (!token && authLink) linkQuery += `?link_auth=${authLink}`
        const response = await axios.post(
            `${serverBaseURL}/short-link${linkQuery}`,
            {
                params,
                groupId,
                pdv,
            },
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return null
    }

    public static async sendBarCodeByEmail(
        email: string,
        firstName: string,
        barCode: string,
        groupId: string,
        pdv: string | number,
        lang: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const token = await StoreService.getInstance().persistant.get("token")
        const authLink = process.env.REACT_APP_CUSTOMER_AUTH_LINK
        let linkQuery = ""
        if (!token && authLink) linkQuery += `?link_auth=${authLink}`
        const response = await axios.post(
            `${serverBaseURL}/checkin/barcode${linkQuery}`,
            {
                email,
                firstName,
                barCode,
                groupId,
                pdv,
                lang,
            },
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return null
    }
    public static async printBarCode(
        barCode: string,
        firstName: string,
        lastName: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const token = await StoreService.getInstance().persistant.get("token")
        const authLink = process.env.REACT_APP_CUSTOMER_AUTH_LINK
        let linkQuery = ""
        if (!token && authLink) linkQuery += `?link_auth=${authLink}`
        const response = await axios.post(
            `${serverBaseURL}/checkin/barcode/print${linkQuery}`,
            {
                barCode,
                firstName,
                lastName,
            },
            {
                headers,
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return null
    }
}

export default LinkAPI
